









































































import Vue, { PropType } from "vue";
import { mapGetters } from "vuex";
import moment from "moment";
import RecordCard from "@/components/vue-components/RecordCard.vue";
import IconBookingArrowRight from "@/assets/icons/IconBookingArrowRight.vue";
import { CompanyObject } from "./types/index";
import type { RecordObject } from "./types/index";

export default Vue.extend({
  name: "AppointmentsDashboard",
  data: () => {
    return {
      timezone: moment.tz.guess() as string,
      baseUrl: process.env.VUE_APP_VELLO_URL as string,
      companyLogoUrl: "" as string,
      isOpen: false as boolean
    };
  },
  components: {
    RecordCard,
    IconBookingArrowRight
  },
  props: {
    records: {
      type: Array as PropType<RecordObject[]>,
        default() {
        return [];
      }
    },
    companies: {
      type: Object,
      default() {
        return {};
      }
    },
    offices: {
      type: Object,
      default() {
        return {};
      }
    },
    resources: {
      type: Object,
      default() {
        return {};
      }
    },
    services: {
      type: Object,
      default() {
        return {};
      }
    },
    title: {
      type: String,
      default() {
        return "";
      }
    }
  },
  computed: {
    ...mapGetters(["GET_CSRF_INFORMATION"])
  },
  methods: {
    goToCompanyWebsite(company: CompanyObject): void {
      window.open(this.baseUrl + "/" + company.url);
    },
    open() {
      this.isOpen = !this.isOpen;
    },
    openDropDwn(companies: CompanyObject[]): void {
      const url = Object.values(companies).map(
        (company: CompanyObject) => company.url
      );
      const companyCalendar = this.baseUrl + "/" + url[0];

      Object.keys(companies).length > 1
        ? this.open()
        : window.open(companyCalendar);
    },
    handleClickOutside(): void {
      this.isOpen = false;
    }
  }
});
